// extracted by mini-css-extract-plugin
export default {"backdrop":"AppLoader_backdrop__p8FR6","card":"AppLoader_card__uxdIB","spinner":"AppLoader_spinner__keIw0","spin":"AppLoader_spin__az-Q3","text":"AppLoader_text__p4-8V"};